import React, { useEffect, useState, useRef } from "react";
import { PenneoAuthExchangeRequest, PenneoAuthExchangeResponse } from "../importContractsFromPenneoDialog/ImportContractsFromPenneoDialog.types.ts";
import { post } from "../../common/api/apiShared.ts";
import { useLocation, useNavigate } from "react-router";
import { DotLegalFullScreenSpinner } from "@dotlegal/dotlegal-ui-components";
import { useUrlProvider } from "../../useUrlProvider.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

function PenneoCallback() {
    const navigate = useNavigate();
    const { getContractsUrl } = useUrlProvider();
    const [isConnecting, setIsConnecting] = useState(true);
    const hasProcessedCallback = useRef(false);

    const clearPKCEData = () => {
        sessionStorage.removeItem("penneo-oauth-state");
        sessionStorage.removeItem("penneo-code-verifier");
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");
        const state = urlParams.get("state");

        if (code && state && !hasProcessedCallback.current) {
            hasProcessedCallback.current = true;
            handleOAuthCallback(code, state);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const authExchangeMutation = useDotLegalMutation((data: PenneoAuthExchangeRequest) => post<PenneoAuthExchangeResponse>("/penneo/auth/exchange", data), {
        onSuccess: (response) => {
            // Store the access token and base URL for future API calls
            clearPKCEData();
            const tokenData = response.value();
            sessionStorage.setItem("penneo-access-token", tokenData.accessToken);
            sessionStorage.setItem("penneo-token-expires", (Date.now() + tokenData.expiresIn * 1000).toString());
            sessionStorage.setItem("penneo-base-url", tokenData.baseUrl);

            // Navigate to contracts page with query parameter to show Penneo import dialog
            navigate(getContractsUrl() + "?showPenneoImport=true", { replace: true });
        },
    });

    const handleOAuthCallback = (code: string, state: string) => {
        const savedState = sessionStorage.getItem("penneo-oauth-state");
        const codeVerifier = sessionStorage.getItem("penneo-code-verifier");

        if (state !== savedState) {
            throw new Error("Invalid state parameter");
        }

        if (!codeVerifier) {
            throw new Error("Code verifier not found");
        }

        authExchangeMutation.mutate({ code, codeVerifier, state });
    };

    return <DotLegalFullScreenSpinner />;
}

export default PenneoCallback;
